module.exports = __webpack_public_path__ + "static/media/gcdef_103.22c4b845.ico";